import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译资源
import zhCN from './locales/zh-CN/translation.json';
import enUS from './locales/en-US/translation.json';
import koKR from './locales/ko-KR/translation.json';

const resources = {
  'zh-CN': {
    translation: zhCN
  },
  'en-US': {
    translation: enUS
  },
  'ko-KR': {
    translation: koKR
  }
};

// 获取URL中的语言参数
const getUrlLanguage = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    const supportedLanguages = ['zh-CN', 'en-US', 'ko-KR'];
    
    if (langParam && supportedLanguages.includes(langParam)) {
      console.log('i18n初始化：检测到URL语言参数:', langParam);
      
      // 延迟移除URL参数，确保i18n完全初始化后再操作
      setTimeout(() => {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.delete('lang');
        const newSearch = currentParams.toString();
        const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
        
        window.history.replaceState(null, '', newUrl);
        console.log('已从URL中移除lang参数');
      }, 100);
      
      return langParam;
    }
  } catch (error) {
    console.error('获取URL语言参数时出错:', error);
  }
  
  return null;
};

// 获取存储的语言设置
const getStoredLanguage = () => {
  return localStorage.getItem('i18nextLng') || 'en-US';
};

// 获取初始语言：优先使用URL参数，然后是存储的语言
const getInitialLanguage = () => {
  const urlLang = getUrlLanguage();
  if (urlLang) {
    // 如果URL中有语言参数，保存到localStorage
    localStorage.setItem('i18nextLng', urlLang);
    return urlLang;
  }
  return getStoredLanguage();
};

i18n
  // 检测用户语言
  .use(LanguageDetector)
  // 将i18n实例传给react-i18next
  .use(initReactI18next)
  // 初始化i18n
  .init({
    resources,
    fallbackLng: 'en-US', // 备用语言
    lng: getInitialLanguage(), // 优先使用URL参数，然后是存储的语言设置
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      checkWhitelist: true
    },

    interpolation: {
      escapeValue: false // React已经默认转义了
    },

    react: {
      useSuspense: false, // 关闭Suspense模式，避免加载闪烁
      bindI18n: 'languageChanged loaded', // 监听语言变化
      bindI18nStore: 'added removed', // 监听存储变化
      transEmptyNodeValue: '', // 空节点值
      transSupportBasicHtmlNodes: true, // 支持基本HTML节点
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'] // 保留的HTML节点
    }
  });

// 监听语言变化，确保更新localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n; 